import { render, staticRenderFns } from "./gAdUnitCode.vue?vue&type=template&id=55c2db2a"
import script from "./gAdUnitCode.vue?vue&type=script&lang=js"
export * from "./gAdUnitCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports